import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BaseUrl = process.env.REACT_APP_BASEURL_SERVER;

export const myAccountAPI = createApi({
  reducerPath: "myAccountAPI",
  baseQuery: fetchBaseQuery({
    baseUrl: BaseUrl,
    prepareHeaders: (headers, { getState }) => {
      const accessToken = localStorage.getItem("access_token");

      // If the user is logged in, add the access token to the headers
      if (accessToken) {
        headers.set("Authorization", `Bearer ${accessToken}`);
      }
      headers.set("Accept", "application/json");
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getOrderData: builder.query({
      query: (userId) => `user/orders/list-orders/${userId}`,
    }),
    getOrderDetailsData: builder.query({
      query: ({ id, order_id }) => `orders/${id}/${order_id}`,
    }),
    getBillingAddressData: builder.query({
      query: () => `user/billing-address`,
    }),
    getShippingAddressData: builder.query({
      query: () => `user/shipping-address`,
    }),
    updateBillingAddress: builder.mutation({
      query: ({ billingId, body }) => ({
        url: `/user/billing-address/${billingId}`, // Billing ID in URL
        method: "POST",
        body,
      }),
    }),
    updateShippingAddress: builder.mutation({
      query: ({ shippingId, body }) => ({
        url: `user/shipping-address/${shippingId}`, // Billing ID in URL
        method: "POST",
        body,
      }),
    }),
    addBillingAddress: builder.mutation({
      query: (body) => ({
        url: `/user/billing-address`, // No billing ID since it's a new record
        method: "POST",
        body,
      }),
    }),
    addShippingAddress: builder.mutation({
      query: (body) => ({
        url: `/user/shipping-address`, // No shipping ID since it's a new record
        method: "POST",
        body,
      }),
    }),

    getAccountData: builder.query({
      query: () => `user/user-me`,
    }),

    updateAccountDetails: builder.mutation({
      query: ({ body }) => ({
        url: `user/update-user`, // Billing ID in URL
        method: "PATCH",
        body,
      }),
    }),

    logout: builder.mutation({
      query: (formData) => ({
        url: "user/user-logout",
        method: "POST",
        body: formData,
      }),
    }),

    refreshToken: builder.mutation({
      query: (formData) => ({
        url: "user/user-refresh",
        method: "POST",
        body: formData,
      }),
    }),

  }),
});

export const {
  useLogoutMutation,
  useGetOrderDataQuery,
  useGetOrderDetailsDataQuery,
  useGetBillingAddressDataQuery,
  useGetShippingAddressDataQuery,
  useUpdateBillingAddressMutation,
  useUpdateShippingAddressMutation,
  useAddBillingAddressMutation,
  useAddShippingAddressMutation,
  useGetAccountDataQuery,
  useUpdateAccountDetailsMutation,
  useRefreshTokenMutation
} = myAccountAPI;
